import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';

const ARROW_CURSOR_ELEMENT_ID = 'arrow-cursor-element';
const ARROW_CURSOR_HOVER_CLASS = 'arrow-cursor';

class ArrowCursorHover {
    constructor() {
        this._arrowCursorElement = document.getElementById(ARROW_CURSOR_ELEMENT_ID);
        this._arrowCursorLinks = document.querySelectorAll(`.${ARROW_CURSOR_HOVER_CLASS}`);

        this._arrowCursorElement && this._arrowCursorLinks.length && innerWidth >= screenSm && this._run();
    }
    _run() {
        document.body.addEventListener('pointermove', this._mouseMove.bind(this));
        document.body.addEventListener('pointerdown', this._mouseMove.bind(this));

        this._arrowCursorLinks.forEach((link) => {
            link.addEventListener('pointerenter', this._showArrowCursor.bind(this));
            link.addEventListener('pointerleave', this._hideArrowCursor.bind(this));
        });
    }
    _mouseMove(e) {
        this._arrowCursorElement.style.left = `${e.clientX}px`;
        this._arrowCursorElement.style.top = `${e.clientY}px`;
    }
    _showArrowCursor(e) {
        this._arrowCursorElement.classList.remove('scale-0', 'opacity-0');
        e.target.classList.add('cursor-none');
    }
    _hideArrowCursor(e) {
        this._arrowCursorElement.classList.add('scale-0', 'opacity-0');
        e.target.classList.remove('cursor-none');
    }
}
const arrowCursorHover = new ArrowCursorHover();
